import { Component, Input } from '@angular/core';

export type Breadcrumbs = Array<{ text: string, path: string }>;

@Component({
  selector: 'app-breadcrum',
  templateUrl: './breadcrum.component.html',
  styleUrls: ['./breadcrum.component.css'],
})
export class BreadcrumComponent {

  @Input() breadcrums: Breadcrumbs = [
    { text: 'Inicio', path: '/dashboard' },
    { text: 'Aprobar Solicitudes', path: '/license/approve' },
  ]

  constructor() { }
}
